import React, { Component } from 'react';
import { Modal, Table, Switch } from 'antd';
import { MenuOutlined, StopOutlined } from '@ant-design/icons';
import { PropTypes } from 'prop-types';
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import './FhColumnSettingModal.less';
import { handleMouseDown } from '../utils/DragUtil';

const DragHandle = sortableHandle(() => <MenuOutlined style={{ cursor: 'pointer', color: '#000', width: 60 }} />);

const SortableItem = sortableElement(props => {
  return <tr {...props} style={{ zIndex: '1000' }} />;
});
const SortableContainer = sortableContainer(props => <tbody {...props} />);

/**
 * 表格列设置页
 */
export default class FhColumnSettingModal extends Component {
  // 隐藏列KEY
  columnsHiddenInLocalStorage = [];
  constructor(props) {
    super(props);
    this.state = {
      columnSettingModalVisible: false,
      columnData: [],
      hideColumnSet: new Set()
    };

    this.settingColumns = [
      {
        title: '排序',
        dataIndex: 'sort',
        width: 70,
        className: 'drag-visible',
        // eslint-disable-next-line react/display-name
        render: (_, record) => record.fixed ? <StopOutlined style={{ cursor: 'not-allowed', color: '#f00', width: 60 }} /> : record.itemFlag ? '' : <DragHandle />
      },
      {
        title: '列名',
        dataIndex: 'title',
        className: 'drag-visible',
        ellipsis: true
      },
      {
        title: '操作',
        dataIndex: 'hideFlag',
        width: 100,
        className: 'drag-invisible',
        // eslint-disable-next-line react/display-name
        render: (text, record) => (
          !record.ellipsis ? <Switch defaultChecked={!this.state.hideColumnSet.has(record.key)} checkedChildren="显示" unCheckedChildren="隐藏" onChange={e => this.showOrHide(record, e)} /> : ''
        )
      }
    ];
  }

  handleMouseDownFun(e) {
    handleMouseDown(e, '.moveModal');
  }

  showOrHide = (record, showFlag) => {
    const { hideColumnSet } = this.state;
    const { tableKey } = this.props;
    const subKeyList = JSON.parse(localStorage.getItem(tableKey + '_columnSetting_children')) || {};
    if (showFlag) {
      // 显示
      hideColumnSet.delete(record.key);
      if (record.itemFlag) {
        // 是子列，判断其父列下的子列是否全为显示
        let allShowFlag = false;
        for (const key of subKeyList[record.parentKey]) {
          if (hideColumnSet.has(key)) {
            // 隐藏列中存在 其子列，跳出循环
            allShowFlag = false;
            break;
          } else {
            allShowFlag = true;
          }
        }
        if (allShowFlag) {
          // 条件满足 父列子列 从隐藏列进行删除
          // 删父列名
          hideColumnSet.delete(record.parentKey);
          // 删子列名 --hideColumnSet.delete
        }// 不满足则只删除该子列 --hideColumnSet.delete
      } else {
        // 不是子列,为父列
        if (record.hasChilds) {
          // 含有子列，删父列子列名
          // 删父列名 ---hideColumnSet.delete
          // 删子列名
          subKeyList[record.key].forEach(subKey => {
            hideColumnSet.delete(subKey);
          });
        }// 不含子列删名
      }
    } else {
      // 隐藏
      hideColumnSet.add(record.key);
      if (record.itemFlag) {
        // 是子列，判断其父列下的子列是否全为隐藏
        let allHiddenFlag = null;
        for (const key of subKeyList[record.parentKey]) {
          if (hideColumnSet.has(key)) {
            allHiddenFlag = true;
          } else {
            // 隐藏列中不存在 其某一子列，跳出循环
            allHiddenFlag = false;
            break;
          }
        }
        if (allHiddenFlag) {
          // 条件满足从父列子列 隐藏列进行添加
          // 加父列名
          hideColumnSet.add(record.parentKey);
          // 删子列名
        } // 不满足则只添加该子列
      } else {
        // 不是子列,为父列
        if (record.hasChilds) {
          // 含有子列，加父列子列名
          // 加父列名
          // 加子列名
          subKeyList[record.key].forEach(subKey => {
            hideColumnSet.add(subKey);
          });
        }// 不含子列加名
      }
    }
    this.setState({
      hideColumnSet
    });
  };

  initColumnsFromLocalStorage = () => {
    const { tableKey, orginColums } = this.props;
    // 从localStorage获取显示列KEY
    this.columnsInLocalStorage = JSON.parse(localStorage.getItem(tableKey + '_columnSetting')) || [];
    // 从localStorage获取隐藏列KEY
    this.columnsHiddenInLocalStorage = JSON.parse(localStorage.getItem(tableKey + '_hiddenColSeting')) || [];
    // 所有列增加index
    orginColums.forEach((col, idx) => {
      col.index = idx;
      if (col.children) {
        col.children.forEach((colItem, colIndex) => {
          colItem.index = idx + '-' + colIndex;
          colItem.itemFlag = 1;
          colItem.parentKey = col.key;
        });
      }
    });

    // localStorage无数据时、使用原始列
    if (this.columnsInLocalStorage.length === 0) {
      this.columns = orginColums;
      this.props.onInit(this.columns);
      return;
    }

    // localStorage有数据时、通过存储key值恢复显示列信息
    const recoverColumn = [];

    // 取出包含子列的所有列
    const allColums = [];
    // 取出子列
    const subColums = [];
    orginColums.forEach((item) => {
      if (item.children) {
        allColums.push({ ...item, children: null, hasChilds: true });
        for (const subindex in item.children) {
          // 为子列添加子列标志 itemFlag
          allColums.push({ ...item.children[subindex], itemFlag: 1, parentKey: item.key });
          subColums.push({ ...item.children[subindex], itemFlag: 1, parentKey: item.key });
        }
      } else {
        allColums.push({ ...item, children: null });
      }
    });

    for (const colkey of this.columnsInLocalStorage) {
      const colDef = allColums.find(item => item.key === colkey);
      // colDef &&  防止 该页面增加了列,再次进入时没有 增加列 报错
      if (colDef && !colDef.itemFlag) {
        // 非子列，是父列,进行赋值操作，否则无操作
        if (!recoverColumn.some(item => item.key === colkey)) {
          // 排序数据中没有该父列
          if (colDef.hasChilds) {
            // 有子列，则填入,children初始化数组
            recoverColumn.push(Object.assign({}, colDef, { children: [] }));
          } else {
            // 没有子列，则填入
            recoverColumn.push(colDef);
          }
        }
      } else if (colDef) {
        // 是子列
        if (recoverColumn.some(item => item.key === colDef.parentKey)) {
          // 排序数据已存在父列，获取索引填入子列
          const colIndex = recoverColumn.findIndex(item => item.key === colDef.parentKey);
          // 父列中没有改子列，则填入
          if (!recoverColumn[colIndex].children.some(subcol => subcol.key === colDef.key)) {
            recoverColumn[colIndex].children.push(colDef);
          }
        } else {
          // 不存在父列，添加并填入子列
          const colfaDef = allColums.find(item => item.key === colDef.parentKey);
          recoverColumn.push(Object.assign({}, colfaDef, { children: colDef }));
        }
      }
    }
    // 恢复显示列回调方法、反应到页面
    this.columns = recoverColumn;
    this.props.onInit(this.columns);
  };

  componentDidMount() {
    this.props.onRef(this);
    this.initColumnsFromLocalStorage();
    this.loacalSubColnum();
  }

  componentWillUnmount() {
    this.props.onRef(null);
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const { columnData } = this.state;
    if (oldIndex !== newIndex) {
      const newData = arrayMove([].concat(columnData), oldIndex, newIndex).filter(el => !!el);
      this.setState({ columnData: newData });
    }
  };

  DraggableContainer = props => {
    return <SortableContainer useDragHandle disableAutoscroll helperClass="row-dragging" onSortEnd={this.onSortEnd} {...props} />;
  };

  DraggableBodyRow = ({ className, style, ...restProps }) => {
    const { columnData } = this.state;
    const index = columnData.findIndex(x => x.index === restProps['data-row-key']);
    return <SortableItem index={index} {...restProps} />;
  };

  editColumnSetting = () => {
    const { orginColums } = this.props;
    const columnData = [];
    const orginColumsMap = new Map();
    const overCol = []; // 存储新增列,例如汇总后的新增列
    // 获取本地存储的显示与隐藏列
    const columnsHiddenInLocalStorage = JSON.parse(localStorage.getItem(this.props.tableKey + '_hiddenColSeting')) || [];
    const columnsInLocalStorage = JSON.parse(localStorage.getItem(this.props.tableKey + '_columnSetting')) || [];
    const hideColumnSet = new Set(columnsHiddenInLocalStorage);
    // 所有列增加index
    orginColums.forEach((col, idx) => {
      col.index = idx;
      if (col.children) {
        col.children.forEach((colItem, colIndex) => {
          colItem.index = idx + '-' + colIndex;
          colItem.itemFlag = 1;
          colItem.parentKey = col.key;
        });
      }
      if ((columnsHiddenInLocalStorage.length || columnsInLocalStorage.length) && !columnsHiddenInLocalStorage.includes(col.key) && !columnsInLocalStorage.includes(col.key)) {
        overCol.push(col);
      }
      orginColumsMap.set(col.key, col);
    });

    const sortOrginColums = []; // 对列排序
    if (columnsInLocalStorage.length) {
      // 本地存储的列为包括新增的所有列
      columnsInLocalStorage.forEach(key => {
        if (orginColumsMap.get(key)) {
          sortOrginColums.push(orginColumsMap.get(key));
        } else {
          // 由于新增列 可能存在多余的列
          // console.log(key, '不存在的key');
        }
      });
    } else {
      sortOrginColums.push(...orginColums);
    }
    sortOrginColums.push(...overCol);

    // 过滤掉隐藏列
    if (columnsHiddenInLocalStorage.length) {
      this.columns = sortOrginColums.filter(item => !columnsHiddenInLocalStorage.includes(item.key));
    } else {
      this.columns = sortOrginColums;
    }

    // 取出包含子列的所有列
    const allColums = [];
    // 取出子列
    const subColums = [];
    orginColums.forEach((item) => {
      if (item.children) {
        allColums.push({ ...item, children: null, hasChilds: true });
        for (const subindex in item.children) {
          // 为子列添加子列标志 itemFlag
          allColums.push({ ...item.children[subindex], itemFlag: 1, parentKey: item.key });
          subColums.push({ ...item.children[subindex], itemFlag: 1, parentKey: item.key });
        }
      } else {
        allColums.push({ ...item, children: null });
      }
    });
    // 计算显示列 与 所有列和隐藏列 的差集
    const diffFaColumns = allColums.filter(col1 => {
      return !(this.columns.some(col2 => col2.key === col1.key) || col1.itemFlag === 1 || !columnsHiddenInLocalStorage.includes(col1.key));
    });
    // eslint-disable-next-line
    // 显示的子列集合
    const showSubCol = [];
    this.columns.forEach((item) => {
      if (item.children) {
        for (const subindex in item.children) {
          // 为子列添加子列标志 itemFlag
          showSubCol.push({ ...item.children[subindex], itemFlag: 1, parentKey: item.key });
        }
      }
    });
    const diffSubColumns = [];
    subColums.forEach(subcol => {
      // 差异子列中没有 该子列,且不存在显示的子列中
      if (!(showSubCol.some(subcol1 => subcol1.key === subcol.key) || diffSubColumns.some(subcol1 => subcol1.key === subcol.key))) {
        // 获取同父列所有子列
        const subCols = subColums.filter(subcol1 => subcol1.parentKey === subcol.parentKey);
        if (diffFaColumns.some(col => col.key === subcol.parentKey)) {
          // 其父列存在差异列中, 获取所有差异子列填入差异子列数组
          diffSubColumns.push(...subCols);
        } else {
          // 其父列不存在差异列中，填入差异子列后 判断其同父元素的列是否全在差异子列中
          diffSubColumns.push(subcol);
          let allDiffFlag = false;
          for (const iterator of subCols) {
            if (diffSubColumns.some(diffSubcol => diffSubcol.key === iterator.key)) {
              allDiffFlag = true;
            } else {
              allDiffFlag = false;
              break;
            }
          }
          if (allDiffFlag) {
            // 全部存在差异列中，查找父列填入
            const faCol = allColums.find(col => col.key === subcol.parentKey);
            diffFaColumns.push(faCol);
          }
        }
      }
    });
    const diffColumns = diffFaColumns.concat(diffSubColumns);
    // 列设置数据添加显示列
    this.columns.forEach(col => {
      if (col.key !== 'action' && col.title !== '　') {
        if (col.children && col.children.length) {
          columnData.push(Object.assign({}, col, { hasChilds: true }));
        } else {
          columnData.push(col);
        }
      }
    });
    // 列设置数据添加隐藏列、设置隐藏Set
    diffColumns.forEach(col => {
      hideColumnSet.add(col.key);
      if (col.key !== 'action' && col.title !== '　') {
        if (col.itemFlag) {
          // 是子列
          if (columnData.some(item => item.key === col.parentKey)) {
            // 排序数据中有其父列，获取索引，填入子列
            const colIndex = columnData.findIndex(item => item.key === col.parentKey);
            // 父列中是否有 该子列
            const childIndex = columnData[colIndex].children.findIndex(item => item.key === col.key);
            if (childIndex === -1) {
              // 父列没有该子列， children 是否null，填入
              if (columnData[colIndex].children === null) {
                columnData[colIndex].children = [];
                columnData[colIndex].children.push(col);
              } else {
                columnData[colIndex].children.push(col);
              }
            }
          } else {
            // 没有其父列，寻其父列，并填入
            const colnum = allColums.find(item => item.key === col.parentKey);
            columnData.push(Object.assign({}, colnum, { children: col }));
          }
        } else {
          // 非子列，父列
          if (!columnData.some(item => item.key === col.key)) {
            // 列排序数据中 无该父列，填入，否则不进行操作
            if (col.hasChilds) {
              // 有子列 获取其全部子列
              const childs = subColums.filter(subcol => subcol.parentKey === col.key);
              columnData.push(Object.assign({}, col, { children: childs }));
            } else {
              // 无子列
              columnData.push(col);
            }
          }
        }
      }
    });
    this.setState({
      columnData,
      hideColumnSet,
      columnSettingModalVisible: true
    });
  };

  hideColumnSettingModal = () => {
    this.setState({
      columnData: [],
      columnSettingModalVisible: false
    });
  };

  reloadColumnsSetting = () => {
    const { tableKey } = this.props;
    const { columnData, hideColumnSet } = this.state;
    const hideColumnList = [...hideColumnSet];
    // 获取操作列
    const actionCol = this.columns.find(item => item.key === 'action');

    // 取出包含子列的所有列
    const allColums = [];
    // 取出子列
    const subColums = [];
    columnData.forEach((item) => {
      if (item.children) {
        allColums.push({ ...item, children: null, hasChilds: true });
        for (const subindex in item.children) {
          // 为子列添加子列标志 itemFlag
          allColums.push({ ...item.children[subindex], itemFlag: 1, parentKey: item.key });
          subColums.push({ ...item.children[subindex], itemFlag: 1, parentKey: item.key });
        }
      } else {
        allColums.push({ ...item, children: null });
      }
    });

    // 重置列数据
    const tempColnumData = [];
    allColums.forEach(item => {
      // 筛选不存在隐藏列中的列
      if (!hideColumnList.includes(item.key)) {
        if (item.itemFlag) {
          // 是子列判断父列是否存在
          if (tempColnumData.some(col => col.key === item.parentKey)) {
            // 存在父列,若父列不存在子列，填入子列
            const faColIndex = tempColnumData.findIndex(col => col.key === item.parentKey);
            if (!tempColnumData[faColIndex].children.some(child => child.key === item.key)) {
              tempColnumData[faColIndex].children.push(item);
            }
          } else {
            // 不存在父列，查找父列,填入子列
            const faCol = tempColnumData.find(col => col.key === item.parentKey);
            tempColnumData.push(Object.assign({}, faCol, { children: [item] }));
          }
        } else {
          // 不是子列,为父列
          if (item.hasChilds) {
            // 有子列，children初始化为[],用于push
            tempColnumData.push(Object.assign({}, item, { children: [] }));
          } else {
            // 没有子列，直接填入
            tempColnumData.push(item);
          }
        }
      }
    });
    this.columns = tempColnumData;

    // 操作列不为空时
    if (actionCol != null) {
      if (actionCol.index === 0) {
        // 操作列在第一列，添加到列表第一列
        this.columns.unshift(actionCol);
      } else {
        // 其他情况，添加到列表最后列
        this.columns.push(actionCol);
      }
    }

    const keyList = [];
    const fixedLeftList = [];
    const fixedRightList = [];
    this.columns.forEach(item => {
      if (item.children && item.children.length) {
        if (item.key) {
          keyList.push(item.key);
          item.children.forEach(subitem => {
            keyList.push(subitem.key);
          });
        }
      } else {
        if (item.fixed === 'left' || item.fixed) {
          fixedLeftList.push(item.key);
        } else if (item.fixed === 'right') {
          fixedRightList.push(item.key);
        } else {
          keyList.push(item.key);
        }
      }
    });
    console.log(this.columns);
    // 把显示列存入localStorage
    localStorage.setItem(tableKey + '_columnSetting', JSON.stringify([...fixedLeftList, ...keyList, ...fixedRightList]));
    // 隐藏列存入本地,用于页面手动设置列 剔除隐藏列
    const hiddenColList = [...hideColumnSet];
    if (hiddenColList.length) {
      localStorage.setItem(this.props.tableKey + '_hiddenColSeting', JSON.stringify(hiddenColList));
    } else {
      localStorage.removeItem(this.props.tableKey + '_hiddenColSeting');
    }
    this.loacalSubColnum();
    // 回调调用出方法、列设置信息反应到页面
    this.props.onReload(this.columns);
    this.hideColumnSettingModal();
  };

  loacalSubColnum = () => {
    const { tableKey, orginColums } = this.props;
    const subkKeyList = {};
    orginColums.forEach(item => {
      if (item.children && item.children.length) {
        if (item.key) {
          subkKeyList[item.key] = [];
          item.children.forEach(subitem => {
            subkKeyList[item.key].push(subitem.key);
          });
        }
      }
    });

    // 把子列对象存入localStorage
    JSON.stringify(subkKeyList) !== '{}' && localStorage.setItem(tableKey + '_columnSetting_children', JSON.stringify(subkKeyList));
  }

  render() {
    const { columnSettingModalVisible, columnData } = this.state;

    return (
      // 添加destroyOnClose属性
      <Modal
        title={
          <div className='moveModalTitle' onMouseDown={this.handleMouseDownFun}>
            列名显示设置
          </div>
        }
        visible={columnSettingModalVisible}
        className="addModal paddingZeroModal moveCss moveModal"
        style={{ left: 'calc(50% - 260px)' }}
        onCancel={this.hideColumnSettingModal}
        onOk={this.reloadColumnsSetting}
        destroyOnClose
      >
        <Table
          tableKey={'tb_columnSettingModal'}
          dataSource={columnData}
          columns={this.settingColumns}
          pagination={false}
          bordered
          size={'small'}
          rowKey="index"
          components={{
            body: {
              wrapper: this.DraggableContainer,
              row: this.DraggableBodyRow
            }
          }}
        />
      </Modal>
    );
  }
}

FhColumnSettingModal.propTypes = {
  orginColums: PropTypes.array.isRequired,
  tableKey: PropTypes.string.isRequired,
  onRef: PropTypes.func.isRequired,
  onInit: PropTypes.func,
  onReload: PropTypes.func
};
